import { apiAdmin } from './cliente';

export const obterBrandingPorSlug = (slug) => apiAdmin.get(`/api/v1/branding?slug=${slug}`);
